import { store } from '@wajeez-web/stores/base';
import { handleDispatchResult } from '@wajeez-web/core/utils';
import { Server } from '@wajeez-web/core/api-base';

import {
  getComponentTypeByIdMultilingualAsync,
  createComponentTypeMultilingualAsync,
  editComponentTypeMultilingualAsync,
} from './slices';

export const getComponentTypeByIdMultilingual = async (
  id: number,
  onSuccess?: () => void | Promise<void>
) => {
  const res = await store.dispatch(getComponentTypeByIdMultilingualAsync(id));

  return handleDispatchResult(res, onSuccess);
};

export const createComponentTypeMultilingual = async (
  data: Server.CreateComponentTypeV2Input,
  onSuccess?: (componentTypeId: number) => void | Promise<void>
) => {
  const res = await store.dispatch(createComponentTypeMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};

export const editComponentTypeMultilingual = async (
  data: Server.UpdateComponentTypeInput,
  onSuccess?: (componentTypeId: number) => void | Promise<void>
) => {
  const res = await store.dispatch(editComponentTypeMultilingualAsync(data));

  return handleDispatchResult(res, onSuccess);
};
